import { ApiConnector, GET } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/olympiad');
    const API_v2 = ApiConnector('/olympiad', true);
    return {
        OlympiadList: async () => await API(GET, '/stat/students', false, false).call(),
        ChampionsList: async () => await API(GET, '/champions/students', false, false).call(),
        OlympiadCount: async () => await API_v2(GET, '/count', false, false).call(),
        OlympiadListForPeriod: async query => await API_v2(GET, '/stat/students', false, query).call(false, true),
        ChampionsListForPeriod: async query => await API_v2(GET, '/champions/students', false, query).call(false, true),
        GetAllOlympiadChampions: async (data, query) =>
            await API_v2(GET, '/champions/students/count', false, query).call(data),
        GetOlympiadChampionsForPeriod: async (data, query) =>
            await API_v2(GET, '/teacher/stat', false, query).call(data),
        GetTeachersName: async () => await API_v2(GET, '/champions/students/select', false, false).call(),
    };
})();
